module.exports = __webpack_public_path__ + "static/media/harmonie-1.ee0189bd.jpg";